import {apiFactory} from 'services/ApiFactory'
import * as applicationType from 'enums/applicationTypes'
export function userService(http) {
    const serviceName = "User";

    return {
        getRoles: (userId) => {
           //Call from Apis/GeneralServices/UserService
           let c;
           return apiFactory.intranetApiFactory.authorization.getUserRoleApplicationPermission(userId,applicationType.APPLICATION_ERMS)
            .then(result=>{
               return result.data.roles;
            });

            // return  [
            //     {
            //         id: 2,
            //     },
            //     {
            //         id: 3
            //     },
            //     {
            //         id: 4
            //     }
            // ]
        },
        getCurrentUser: ()=>{
            //debugger;
           //Call from Apis/GeneralServices/UserService
           const userEntity= apiFactory.intranetApiFactory.generalInformation.getPresentUserGeneralInfo();
            return {
                userId:userEntity.userId,//'732ad59e-1e99-417d-a76d-9ace79016e43',//
                disciplineId:userEntity.disciplineId||100012,
                estekhdam:userEntity.emplacementCostCenterCode,
                prsCostCenterSubCode:userEntity.employmentCostCenterSubCode,
                emplacementCostCenterCode:userEntity.emplacementCostCenterCode,
                employmentCostCenterSubCode:userEntity.employmentCostCenterSubCode,
                employmentCostCenterCode:userEntity.employmentCostCenterCode
            }
        },
        getRoleMember:(userId,roleTypeId)=>{
           //Call from Apis/GeneralServices/UserService
           const c= apiFactory.intranetApiFactory.authorization.getUserRoleMember(userId,roleTypeId)
           .then(result=>{
               debugger;
                return result.data.roleMemberDisciplineProject.map(
                    a=>{
                        return {
                            disciplineId:a.discipline.id,
                            projectId:a.project.id
                        }
                    });
                    
                    //return roleMembers;
                });
            return c;
        },
        getEmployee:(estekhdam,prsCostCenterSubCode)=>{
           //Call from Apis/GeneralServices/UserService
           const data={
                    estekhdam,
                    prsCostCenterSubCode
            }
            return http.post("Erms/GetEmployee",data)
        }
     
    }

}